<div class="login-page" style="background-image: url('/assets/images/bg/rawpixel-589084-unsplash-1400.jpg')">
  <nz-spin [nzSize]="'large'" [nzSpinning]="authenticationService.loadingFromToken">
    <div class="login-container">
      <div class="login-left">
        <div class="login-login">Login</div>
        <div class="login-eula">
          Use your credentials to securely login to {{organizationMetaData.name}} <strong>New Business Underwriting Digital
            Platform</strong>
          <img src="/assets/images/{{organizationMetaData.logoname}}" alt="" class="d-b m-t-15 w-100-pc" />
          <small class="d-b m-t-15 text-a-center">
            Powered by
            <a href="https://metamorphtech.com/?from=app&track=claims" style="color:#2D2F36" target="_blank"
              rel="external follow" class="d-b">MetaMorphoSys Digital Insurance Platform</a>
          </small>
        </div>

      </div>
      <div class="login-right">
        <form class="login-form">
          <div class="login-header"><span>Login</span></div>
          <div class="input-container">
            <span><i nz-icon class="icon" nzType="user" nzTheme="outline"></i></span>
            <input type="email" id="email" placeholder="Username" name="email" class="login-input-login" [(ngModel)]="loginContext.username" />
          </div>
          <div class="input-container">
            <span><i class="icon" nz-icon nzType="lock"  nzTheme="outline"></i></span>
            <input type="password" id="password" placeholder="Password" name="password" class="login-input-login" [(ngModel)]="loginContext.password" />
          </div>
          <input type="submit" id="login-submit" value="{{'Login' | translate}} &raquo;" class="login-button-login"
            (click)="login(loginContext)">
          <mms-oauth [code]="oauthParams.code" [dummyval]="false" [provider]="oauthParams.provider" [state]="oauthParams.state" [applicationid]="oauthParams.applicationId" [appsource]="oauthParams.applicationSource" (callbackResponse)="elementResp($event)"></mms-oauth>

        </form>
      </div>
    </div>
  </nz-spin>


    <div *ngIf="prefetch" id="ico-prefetch" style="width:100%;height:1px;overflow: hidden;opacity:0">

        <!-- Transaction-->
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        <i nz-icon nzType="safety"></i>
        <i nz-icon nzType="file-unknown"></i>
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        <i nz-icon nzType="file-text"></i>
        <i nz-icon nzType="heart"></i>
        <i nz-icon nzType="team"></i>
        <i nz-icon nzType="medicine-box"></i>
        <i nz-icon nzType="medicine-box" nzTheme="outline"></i>
        <i nz-icon nzType="bank"></i>
        <i nz-icon nzType="dollar"></i>
        <i nz-icon nzType="wallet"></i>
        <i nz-icon nzType="exception"></i>
        <i nz-icon nzType="audit"></i>
        <i nz-icon nzType="down"></i>
        <i nz-icon nzType="inbox"></i>
        <i nz-icon nzType="user" nzTheme="outline"></i>
        <i nz-icon nzType="user-add" nzTheme="outline"></i>
        <i nz-icon nzType="star" nzTheme="outline"></i>
        <i nz-icon nzType="clock-circle-o"></i>
        <i nz-icon nzType="profile"></i>
        <i nz-icon nzType="reconciliation"></i>
        <i nz-icon nzType="read"></i>
        <i nz-icon nzType="dot-chart"></i>

        <!-- Landing Page -->
        <i nz-icon nzType="home"></i>
        <i nz-icon nzType="folder"></i> <!-- Sub menu -->
        <i nz-icon nzType="cluster"></i>
        <i nz-icon nzType="file-protect"></i>
        <i nz-icon nzType="file-search"></i>
        <i nz-icon nzType="file-pdf"></i>
        <i nz-icon nzType="file-done"></i>
        <i nz-icon nzType="logout"></i>

    </div>

</div>